import { sitesPipelineStore } from "../store";

export function setScrollOffsetByStageId(stageId: string, index: number) {
  sitesPipelineStore.scrollOffsetByStageId[stageId] = index;
}
